import { ChargingPaymentMethod } from '@/types/Payment'
import { useStartCharging } from './useStartCharging'

export enum StartChargingStep {
  PENDING_BALANCE = 'pending_balance',
  AMOUNT = 'amount',
  PAYMENT_METHOD = 'payment_method',
  IDLE_RATE_CONFIRMATION = 'idle_rate_confirmation',
  ADD_CARD = 'add_card',
  CONFIRMATION = 'confirmation',
  PROCESS_PAYMENT = 'process_payment',
}

export interface StartChargingState {
  currentStep: StartChargingStep
  amount: number | null
  paymentMethod: ChargingPaymentMethod | null
  selectedCardId: number | null
  isProcessing: boolean
  useWalletBalance: boolean | null
}

export interface ChargingStepProps {
  startChargingMethods: ReturnType<typeof useStartCharging>
}
